import React from "react";
import { CheckCircle2 } from "lucide-react";
import { translate as i18n } from "@/i18n";

const OUTCOMES = ["analysis", "next", "assistant", "documents"];

export function CompactPricingOutcomes({ className = "" }) {
  return (
    <ul className={`space-y-3 ${className}`} data-testid="compact-pricing-outcomes">
      {OUTCOMES.map((key) => (
        <li key={key} className="flex items-start gap-2.5">
          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-[#2A9D8F]" />
          <div>
            <h3 className="text-sm font-semibold leading-5 text-slate-900">
              {i18n(`pricingStrategy.outcomes.${key}.title`)}
            </h3>
            <p className="mt-0.5 text-xs leading-4 text-slate-500">
              {i18n(`pricingStrategy.outcomes.${key}.description`)}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}

export function PricingOutcomes({ className = "" }) {
  return (
    <div className={`grid gap-4 md:grid-cols-2 ${className}`}>
      {OUTCOMES.map((key) => (
        <article key={key} className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="flex items-start gap-3">
            <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#2A9D8F]" />
            <div>
              <h3 className="font-semibold text-slate-900">{i18n(`pricingStrategy.outcomes.${key}.title`)}</h3>
              <p className="mt-1 text-sm leading-relaxed text-slate-500">{i18n(`pricingStrategy.outcomes.${key}.description`)}</p>
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}

export function HowItWorks() {
  return (
    <section aria-labelledby="how-it-works-title">
      <h2 id="how-it-works-title" className="text-center font-head text-2xl font-semibold text-[#0F4C5C]">{i18n("pricingStrategy.howItWorks.title")}</h2>
      <ol className="mt-5 grid gap-3 sm:grid-cols-5">
        {[1, 2, 3, 4, 5].map((step) => (
          <li key={step} className="relative rounded-xl border border-slate-200 bg-white px-3 py-4 text-center text-sm font-medium text-slate-700">
            <span className="mx-auto mb-2 flex h-7 w-7 items-center justify-center rounded-full bg-[#0F4C5C] text-xs font-semibold text-white">{step}</span>
            {i18n(`pricingStrategy.howItWorks.step${step}`)}
          </li>
        ))}
      </ol>
    </section>
  );
}
